import { ConcreteEncodable } from "./ConcreteEncodable";

import { TestObjectEncoder } from "../../encoder/TestObjectEncoder";

import * as CubiqTS from "../../index";

export class TestObject extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.service.messaging.impl.TestObject";

  /*FID=1*/
  public message: string;
  /*FID=2*/
  public publicationTS: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = TestObjectEncoder.Instance;
    this.setEncodableType(TestObject.enType);
    //Model
  }

  public toString(): string {
    return (
      "TestObject[" +
      "message=" +
      this.message +
      "publicationTS=" +
      this.publicationTS +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
